module.exports = __webpack_public_path__ + "media/images/emblems/Chiasso-coat_of_arms-5308236d7f301052c457a8a553e1b98a.svg";